import { render } from "./UsdaComponent.vue?vue&type=template&id=6f0c6d2f&scoped=true"
import script from "./UsdaComponent.vue?vue&type=script&lang=js"
export * from "./UsdaComponent.vue?vue&type=script&lang=js"

import "./UsdaComponent.vue?vue&type=style&index=0&id=6f0c6d2f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0c6d2f"]])

export default __exports__